// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2exQo","selects":"Documents_selects__b3V2a"};